import { render, staticRenderFns } from "./ListTransactionsPage.vue?vue&type=template&id=0164606e"
import script from "./ListTransactionsPage.vue?vue&type=script&lang=js"
export * from "./ListTransactionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports